<template>
  <div>
    <CommonForm @search="formSearch" :form-json="formjson" />
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      :table-json="tablejson"
      :needPagination="true"
      @change="handleTableChange"
    >
    </CommonTable>
  </div>
</template>

<script>
import tablejson from './Model/Tablejson.Index'
import formjson from './Model/Formjson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import getRoleFromPath from '@/mixins/getRoleFromPath'
export default {
  mixins: [formTableMixin, getRoleFromPath],
  data() {
    return {
      tablejson,
      formjson,
      queryApi: this.$api.device.device_user_list
    }
  },
  methods: {
    formSearch(data) {
      const params = {
        ...data,
        deviceId: this.$route.query.id
      }
      this.search(params, null, this.queryApi)
    }
  }
}
</script>

<style></style>
